module.exports = "/images/basketStatus.svg";